module.exports = __webpack_public_path__ + "img/ltkstyletip-4x.eab27e5.jpg";